module.exports = __webpack_public_path__ + "img/twitter.288bcfaa.svg";